import IncluirPauta from '@mui/icons-material/AddBox';
import { AppBar, Box, Toolbar, Tooltip, Typography } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import { action, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import CriarOuEditarPauta from './CriarOuEditarPauta';
import ReactComponent from './ReactComponent';
import NumeroProcesso from './NumeroProcesso';
import NumeroProcessoUtil from '@/util/NumeroProcessoUtil';

class ToolbarCalendario extends ReactComponent {
    handleClickIncluirPauta = () => {
        this.sessaoStore.pautaJulgamentoModal = this.sessaoStore.novaPautaJulgamento();
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            handleClickIncluirPauta: action,
            filtrarTipoSessao: action,
            limparProcessoPesquisa: action,
            buscarPorNumeroProcesso: action
        });
    }

    filtrarTipoSessao = (event) => {
        this.sessaoStore.tipoSessaoFiltrada = event.target.value;
    };

    renderFiltroTipoPauta() {
        return (
            <div
                style={{ width: '600px', marginTop: '5px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}
            >
                <Typography
                    style={{ marginRight: '5px', color: 'white' }}
                    display="inline"
                >
                    Filtrar sessões:{' '}
                </Typography>
                <Tooltip
                    title={'Filtrar tipo de sessão'}
                    placement="top-start"
                    className="corBotaoAmarelo"
                >
                    <FormControl sx={{ width: '290px' }}>
                        <Select
                            displayEmpty
                            inputProps={{ 'aria-label': 'Without label' }}
                            input={<OutlinedInput />}
                            defaultValue={'A'}
                            onChange={this.filtrarTipoSessao}
                            sx={{
                                height: '33px',
                                color: 'white',
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: 'white',
                                    borderWidth: '1px',
                                    borderStyle: 'solid'
                                },
                                '& .MuiSvgIcon-root': {
                                    color: 'white'
                                }
                            }}
                        >
                            <MenuItem value={'A'}>Todas as sessões</MenuItem>
                            <MenuItem value={'O'}>Somente sessões ordinárias</MenuItem>
                            <MenuItem value={'E'}>Somente sessões extraordinárias</MenuItem>
                        </Select>
                    </FormControl>
                </Tooltip>
            </div>
        );
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
        this.sessaoStore.sessoesFiltradas = undefined;
    };

    buscarPorNumeroProcesso = async (numeroCompleto) => {
        if (!NumeroProcessoUtil.validarNumeroProcesso(numeroCompleto.numeroFormatado())) {
            this.mensagemStore.abrirMensagemAlerta(
                'Informe o número completo do processo para realizar a busca na lista de pautas/sessões.'
            );
        } else {
            const pautas = await this.sessaoService.consultarPautasDoProcesso(numeroCompleto.numeroFormatado());
            const sessoesId = pautas.map((pauta) => pauta.sessaoId);
            this.sessaoStore.sessoesFiltradas = sessoesId;
        }
    };

    renderFiltroNumeroProcesso() {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <NumeroProcesso
                    dense
                    tooltip="Número do processo a ser pesquisado na lista de pautas/sessões"
                    clickSearch={this.buscarPorNumeroProcesso}
                    clickLimpar={this.limparProcessoPesquisa}
                    callback={this.buscarPorNumeroProcesso}
                    color="white"
                />
            </Box>
        );
    }

    render() {
        return (
            <AppBar position="static">
                <Toolbar
                    variant="dense"
                    style={{
                        display: 'grid',
                        gridTemplateColumns: '1fr 1fr 1fr',
                        backgroundColor: '#1976d2',
                        minHeight: '40px',
                        color: 'black',
                        paddingLeft: '14px',
                        paddingRight: '8px'
                    }}
                >
                    {this.renderFiltroTipoPauta()}
                    {this.renderFiltroNumeroProcesso()}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Tooltip
                            title={<Typography>Incluir pauta</Typography>}
                            placement="left"
                            className="corBotaoAmarelo"
                        >
                            <IncluirPauta
                                style={{
                                    width: '24px',
                                    height: '24px',
                                    margin: '8px',
                                    fill: 'white',
                                    paddingTop: '4px',
                                    cursor: 'pointer'
                                }}
                                onClick={this.handleClickIncluirPauta}
                            />
                        </Tooltip>
                        <CriarOuEditarPauta />
                    </Box>
                </Toolbar>
            </AppBar>
        );
    }
}

export default inject('stores')(observer(ToolbarCalendario));
